export const TIPOS_CONDICION_TOPE = [
    { id: 1, description: 'Mayor' },
    { id: 2, description: 'Mayor igual' },
    { id: 3, description: 'Menor' },
    { id: 4, description: 'Menor igual' },
    { id: 5, description: 'Igual' },
    { id: 6, description: 'Distinto' },
]
